import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

export const pushApi = createApi({
  reducerPath: "push",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  endpoints(builder) {
    return {
      // Bildirim gönder (anında veya sendAt ile zamanlanmış)
      broadcastPush: builder.mutation({
        query: ({ token, ...body }) => ({
          url: "/api/push/broadcast",
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body,
        }),
      }),
    };
  },
});

export const { useBroadcastPushMutation } = pushApi;
